module.exports = __webpack_public_path__ + "static/img/zpetna_klapka_prirubova.9331614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zpetna_klapka_prirubova.png
// module id = 2Q6H
// module chunks = 1